import { defineStore } from 'pinia'
import { store } from '@/store'
import { queryPickStoreList } from '@/api/mall/trade/placeOrder'

interface GoodsState {
  storeList?: any // 门店列表
  requestWarehouse?: any // 请货仓库
  returnWarehouse?: any // 退货仓库
  goodsListStore?: any // 选购的商品列表
  goodsArrivalCount?: any // 请货商品列表
  containerListStore?: any // 容器列表
}

export const goodsStore = defineStore('goods-data', {
  state: (): GoodsState => ({
    storeList: [],
    requestWarehouse: [],
    returnWarehouse: [],
    goodsListStore: [],
    goodsArrivalCount: [],
    containerListStore: [],
  }),
  getters: {
    getStoreList(state): string {
      return state.storeList || []
    },
    getRequestWarehouse(state): any {
      return state.requestWarehouse || []
    },
    getReturnWarehouse(state): any {
      return state.returnWarehouse || []
    },
    getGoodsListStore(state): any {
      return state.goodsListStore || []
    },
    getGoodsArrivalCount(state): any {
      return state.goodsArrivalCount || []
    },
    getContainerListStore(state): any {
      return state.containerListStore || []
    },

  },
  actions: {
    setStoreList(storeList: any) {
      this.storeList = storeList
    },
    setRequestWarehouse(requestWarehouse: any) {
      this.requestWarehouse = requestWarehouse
    },
    setReturnWarehouse(returnWarehouse: any) {
      this.returnWarehouse = returnWarehouse
    },
    setGoodsListStore(goodsListStore: any) {
      this.goodsListStore = goodsListStore
    },
    setGoodsArrivalCount(goodsArrivalCount: any) {
      this.goodsArrivalCount = goodsArrivalCount
    },
    setContainerListStore(containerListStore: any) {
      this.containerListStore = containerListStore
    },
    // 门店
    async queryPickStoreListFn() {
      const res = await queryPickStoreList({
        ids: [],
      })
      this.setStoreList(res)
      // console.log('门店', res)
    },
  },
  persist: {
    key: 'storeList',
    // 部分持久化状态的点符号路径数组，[]意味着没有状态被持久化(默认为undefined，持久化整个状态)
  },
})

export function useGoodsStoreWithOut() {
  return goodsStore(store)
}
